module.exports = __webpack_public_path__ + "img/439007-1.6bc07647.png";